/**
 * @generated SignedSource<<b0a13ad49f6696d833f652bd0c08f4e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTs"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provisioningAccount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTs"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "usingAccount"
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appName",
        "variableName": "appName"
      },
      {
        "kind": "Variable",
        "name": "endTs",
        "variableName": "endTs"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "provisioningAccount",
        "variableName": "provisioningAccount"
      },
      {
        "kind": "Variable",
        "name": "startTs",
        "variableName": "startTs"
      },
      {
        "kind": "Variable",
        "name": "usingAccount",
        "variableName": "usingAccount"
      }
    ],
    "concreteType": "BillingTransactionsConnection",
    "kind": "LinkedField",
    "name": "lookupbindcardtransactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingTransaction",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcTransactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provisioningAcct",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usingAcct",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bTransactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bDesc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bExtId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cTransactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cExtId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dTransactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerPayingFee",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BindCardTransactionsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "BindCardTransactionsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "211c22e69aab82862ae8ba8e297c5e00",
    "id": null,
    "metadata": {},
    "name": "BindCardTransactionsQuery",
    "operationKind": "query",
    "text": "query BindCardTransactionsQuery(\n  $mode: Int\n  $provisioningAccount: String\n  $usingAccount: String\n  $appName: String\n  $startTs: Datetime\n  $endTs: Datetime\n  $first: Int\n  $offset: Int\n) {\n  lookupbindcardtransactions(mode: $mode, provisioningAccount: $provisioningAccount, usingAccount: $usingAccount, appName: $appName, startTs: $startTs, endTs: $endTs, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      bcTime\n      bcTransactionId\n      bcAmount\n      pAccountId\n      provisioningAcct\n      uAccountId\n      usingAcct\n      appName\n      paymentOrder\n      bTime\n      bTransactionId\n      bSource\n      bDesc\n      bExtId\n      bAccountId\n      bAmount\n      cTime\n      cTransactionId\n      cSource\n      cExtId\n      cAmount\n      dTransactionId\n      dAmount\n      resellerPayingFee\n    }\n  }\n}\n"
  }
};
})();

node.hash = "80df9090c0218f9e637b49242a98e861";

module.exports = node;
